import { createQueryDataTable, type PropsOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { formatToShortDateOrNull } from '~/util/date';

const LegacyOasisTrackingDataTable = createQueryDataTable('legacy-oasis-tracking');
type TableProps = PropsOfQueryDataTable<typeof LegacyOasisTrackingDataTable>;

const columnDefinitions = LegacyOasisTrackingDataTable.columns([
	{
		header: 'User',
		key: 'name',
		width: 'w-[220px]',
		sortable: true
	},
	{
		header: 'Form Type',
		key: 'oasisTrackingFormType',
		width: 'w-[220px]',
		sortable: true
	},
	{
		header: 'Visit Date',
		key: 'visitDate',
		sortable: true,
		width: 'w-[120px]',
		renderCell: row => formatToShortDateOrNull(row.visitDate, '-')
	},
	{
		header: 'First Sent',
		key: 'dateFirstSentToOfficeUtc',
		sortable: true,
		width: 'w-[120px]',
		renderCell: row => formatToShortDateOrNull(row.dateFirstSentToOfficeUtc, '-')
	},
	{
		header: 'Days First Sent',
		width: 'w-[120px]',
		key: 'daysFirstSentToOffice',
		sortable: true
	},
	{
		header: 'Last Sent',
		key: 'dateLastSentToOfficeUtc',
		sortable: true,
		width: 'w-[120px]',
		renderCell: row => formatToShortDateOrNull(row.dateLastSentToOfficeUtc, '-')
	},
	{
		header: 'Days Last Sent',
		width: 'w-[120px]',
		key: 'daysLastSentToOffice',
		sortable: true
	},
	{
		header: 'Patient',
		key: 'patientName',
		sortable: true,
		renderCell: row => `${row.patientName} (MR#: ${row.patientCode})`,
		exportColumnName: 'patient',
		width: 'w-[300px]'
	}
]);

export function LegacyOasisTrackingTable(props: TableProps) {
	return <LegacyOasisTrackingDataTable.Table columns={columnDefinitions} emptyMessage="No OASIS found" {...props} exportable />;
}
